import React,{ useState } from 'react';
import ReactDOM from 'react-dom';

import 'whatwg-fetch';

//import {getFromStorage, setInStorage,removeFromStorage} from "../utils/storage";
import {AiOutlineCloseCircle} from 'react-icons/ai';
import {FaTelegramPlane} from 'react-icons/fa';
import '../App.css';
import {InfoSheet,ConsentForm} from '../utils/Constants.js';
import MakeConsentPdf from './MakeConsentPdf.js'
import RenderPdf from '../utils/RenderPdf.js'

//server endpoint
import {ENDPOINT} from '../utils/Constants.js';

function SignUp(props){
  let isShowing = props.isShowing;
  let {signedIn, userName} = props.userInfo;
  let [isLoading, setIsLoading]=useState(false);
  let [signUpError, setSignUpError]=useState('');
  //create array of same length as consent form data
  let len=ConsentForm.data.length
  let [consented, setConsented]=useState({info:"",consent:new Array(len).fill('')});
  let [signUpPage, setSignUpPage]=useState('Info');
  let consentError="You will be unable to participate in this study.";
  //D let [consentDoc,setConsentDoc] = useState('');
  let tempDoc = 'empty'
  let [signUpUserName,setSignUpUserName]=useState('');
  let [signUpEmail,setSignUpEmail]=useState('');
  let [signUpPassword,setSignUpPassword]=useState('');
  const [localGroup,setLocalGroup] = useState(Math.random() < 0.5 ? 1 : 2);
  console.log('GroupStart:',localGroup)

  function handleChange(newUserInfo){
    newUserInfo.signedIn=true
    props.onChange(newUserInfo);//change signedIn value in the parent variable to its opposite
  }

  function onNo(key){
    let e_new = {
      info:consented.info,
      consent:consented.consent,
      }
    if (key==='info'){ e_new.info="No" }
    else{ e_new.consent[parseInt(key)]="No"}
    setConsented(e_new)
  }

  function onYes(key){
    let e_new = {
      info:consented.info,
      consent:consented.consent,
      }
    if (key==='info'){ e_new.info="Yes" }
    else{ e_new.consent[parseInt(key)]="Yes"}
    setConsented(e_new)
  }

  function onPageChange(newPage){
    setSignUpPage(newPage)
    onYes("info")
  }

  function onRadioButtonChange(event){ //if a radio button value changes
    event.target.value==="Yes"?
    onYes(event.target.name):
    onNo(event.target.name)
  }

  function onTextboxChangeSignUpUserName(event){
    setSignUpUserName(event.target.value)
  }
  function onTextboxChangeSignUpEmail(event){
    setSignUpEmail(event.target.value)
  }
  function onTextboxChangeSignUpPassword(event){
    setSignUpPassword(event.target.value)
  }

  function onResponseChangeState(message,user,email,pwd){
    setSignUpError(message);
    setIsLoading(false);
    setSignUpUserName(user);
    setSignUpEmail(email);
    setSignUpPassword(pwd);
  }

  function onCloseBox(){
    props.hide();
    setConsented({info:"",consent:consented.consent.fill("")});
    setSignUpError("");
    setSignUpUserName("");
    setSignUpEmail("");
    setSignUpPassword("");
    setSignUpPage('Info');
  }
//auto Sign in when sign up is successful
  function onSignIn(){
    setIsLoading(true);
    fetch(ENDPOINT + '/api/account/signin',
    {
      method: 'POST',
      headers:{
        'Content-Type':'application/json'
        },
      body: JSON.stringify({
        email: signUpEmail,
        password: signUpPassword
        })
    })
    .then(res => res.json())
        .then(json => {
            if(json.success){
              //update App state
              handleChange({
                userToken: json.token,
                userName: json.userName,
                userID: json.user_id,
                email: signUpEmail,
                role: json.role,
                participated: [],
                timeSlot:false,
                group: json.group
              });
              onResponseChangeState('','','','','')
              //on success, reset group for next sign up
              setLocalGroup(Math.random() < 0.5 ? 1 : 2);
            }
            else{
              onResponseChangeState(json.message,signUpEmail,signUpPassword)
            }
        });
    }

//API call when submit button is pressed
  function onSignUp(){
    console.log('Group:',localGroup)
    setIsLoading(true);
    tempDoc = MakeConsentPdf({
        user:signUpUserName,
        email:signUpEmail,
        time:Date().toString()
      })

  ///*
  if (tempDoc !== 'empty'){
    fetch(ENDPOINT + '/api/account/signup',
      {
        method: 'POST',
        headers:{
          'Content-Type':'application/json'
          },
        body: JSON.stringify({
          userName: signUpUserName,
          email: signUpEmail,
          password: signUpPassword,
          consentForm: tempDoc,
          group: localGroup
          })
      })
      .then(res => res.json())
          .then(json => {
              if(json.success){
                //update state for consentDoc
                //D setConsentDoc(tempDoc)
                //sign in once the sign up has been successful
                onSignIn()
              }
              else{
                onResponseChangeState(json.message,signUpUserName,signUpEmail,signUpPassword)
              }
          });
          //*/
      }
      else{
        onResponseChangeState("Empty consent doc",signUpUserName,signUpEmail,signUpPassword)
      }
}

  function onConsentDL(){
  setIsLoading(true);
  fetch(ENDPOINT + '/api/account/getpdf',
  {
    method: 'POST',
    headers:{
      'Content-Type':'application/json'
      },
    body: JSON.stringify({
      email: props.userInfo.email
      })
  })
  .then(res => res.json())
      .then(json => {
          if(json.success){
            //update App state
            onResponseChangeState('')
            RenderPdf(json.consentForm,"pdf0")
          }
          else{
            onResponseChangeState(json.message)
          }
      });
}

  function consentItem( id, errorText ){
    return(
      <div className="consentItem">
        <div className="consentButtons" onChange={onRadioButtonChange}>
          <div className="consent-left">{ConsentForm.data[id]}</div>
          <div className="consent-right">
          <input type="radio" value="Yes" name={id} /><label>Yes</label>
          <input type="radio" value="No" name={id} /><label>No</label>
          </div>
        </div>
        {/*console.log("Consented? ",id, consented.consent[id])*/}
        <p className="error right" style={{display: consented.consent[id]==="No" ? "block" : "none"}}>{errorText}</p>
        <hr/>
      </div>
    )
  }

  let info=()=>(
    <div id="info" style={{display: signUpPage==='Info' ? "block" : "none"}}>

      <div className="infoBox">
        <h1 className="center">{InfoSheet.title}</h1>
        {InfoSheet.data.map(
          (item)=> (
            <div>
              <p className="question">{item.question}</p>
              <p className="answer">{item.answer}</p>
            </div>
          ))
        }
      </div>
      <div className="actionBox center">
        <hr/>
        <p className="consent">I have read the information sheet.</p>
        <button className="ynButton green" onClick={()=>onPageChange('Consent')}>Yes</button>
          {/*  <button className="ynButton green" onClick={()=>setInStorage('info',signUpUserName)}>Yes</button> */}
        <button className="ynButton red" onClick={()=>onNo('info')}>No</button>
        <p className="error" style={{display: consented.info==="No" ? "block" : "none"}}>{consentError}</p>
      </div>
    </div>
  )

  let consent=()=>(
    <div style={{display: signUpPage==='Consent' ? "block" : "none"}}>
      <h1 className="center">Consent Form</h1>
        {ConsentForm.data.map(
          (item,index)=>(consentItem( index, consentError))
        )}

      <div className="center" style={{display: consented.consent.every(item=>item==='Yes')
       ? "block" : "none"}}>
        <button className="textButton blue flexButton" type="submit" onClick={()=>onPageChange('Register')}>Submit <FaTelegramPlane className="iconR"/></button>
      </div>
    </div>
  )

  let register=()=>(
    <div id="register" className='center' style={{display: signUpPage==='Register' ? "block" : "none"}}>
      <h1>Sign Up</h1>
      {/*optionally with an error message, if something went wrong in a previous login*/}
      <p className='error message' style={{display: signUpError!=='' ? "block" : "none"}}>{signUpError}</p>
      <div className="formContainer">
        <div className="formInnerContainer">
          <input type="text" placeholder="username" className="textInputField"
            value={signUpUserName}
            onChange={onTextboxChangeSignUpUserName}/>
          <input type="email" placeholder="your@email.ie" className="textInputField"
            value={signUpEmail}
            onChange={onTextboxChangeSignUpEmail}/>
          <input type="password" placeholder="password" className="textInputField"
            value={signUpPassword}
            onChange={onTextboxChangeSignUpPassword}/>
          <button className="textButton blue flexButton" type="submit" onClick={onSignUp}>Sign me up!</button>
        </div>
      </div>
    </div>
  )

  let loading=()=>(
    <div className='center'>
      <h2>Signing you up...</h2>
    </div>
  )


  if(isShowing){
    return(
      ReactDOM.createPortal(
        <React.Fragment>

          <div className="modal-wrapper" aria-modal aria-hidden tabIndex={-1} role="dialog">
            <div className="modal-overlay" onClick={onCloseBox}/>
            <div className="modal" >
              <div className="modal-header">
                <button type="button" className="modal-close-button" data-dismiss="modal" aria-label="Close" onClick={onCloseBox}>
                  <span aria-hidden="true"><AiOutlineCloseCircle/></span>
                </button>
              </div>
              {isLoading ? //if still loading, show loading screen
                <div>{loading()}</div>
              : !signedIn ? //otherwise, if user's not signed in, show signup form
              <div>
                  <div>{info()}</div>
                  <div>{consent()}</div>
                  <div>{register()}</div>
              </div>
                //if we're signed up, welcome
                :
              <div className='center'>
                <h1>Welcome, {userName}!</h1>
                <h2>You have successfully signed up for this study.</h2>
                <button className="textButton blue flexButton" type="submit" onClick={onConsentDL}>Download Consent Form</button>
                <a id="pdf0" href="/"> </a>
              </div>
                }
            </div>
          </div>
        </React.Fragment>, document.body
      )
    )
  }
  else{
    return null
  }
}

export default SignUp;
